<template>
    <layout v-cloak>
        <div class="row">
            <div class="col-sm-12">
                <form autocomplete="off" method="post" data-vv-scope="form" @keyup.enter="" @submit.prevent="saveItem">
                    <div class="row mb-3">
                        <div class="col-sm-auto">
                            <h1 class="content-title">{{ form.title }}</h1>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <div class="form-group form-inline flex-nowrap align-items-start">
                                <label>Tipo:</label>
                                <div class="form-control-static">{{form.service?form.service.description:emptyField}}</div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <div class="form-group form-inline flex-nowrap align-items-start">
                                <label>URL:</label>
                                <div class="form-control-static">{{form.url}}</div>
                            </div>
                        </div>
                    </div>
                    <div class="row" v-if="form.description">
                        <div class="col">
                            <div class="form-group form-inline flex-nowrap align-items-start">
                                <label>Abstract:</label>
                                <div class="form-control-static">{{form.description}}</div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <div class="form-group form-inline flex-nowrap align-items-start">
                                <label>Abstract:</label>
                                <div class="form-control-static">{{form.abstract?form.abstract:emptyField}}</div>
                            </div>
                        </div>
                    </div>
                    <div class="row mb-sm-4">
                        <div class="col">
                            <div class="form-group form-inline flex-nowrap align-items-start">
                                <label>Keywords:</label>
                                <div class="form-control-static">{{form.keywords?form.keywords:emptyField}}</div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <!-- //<h3>Service Resources <span class="badge">14</span></h3> -->
                            <h3>Service Resources <span class="ml-1 badge badge-info">{{form.layers_count}}</span></h3>
                        </div>
                    </div>
                    <div class="row" v-if="form.layers_count>0">
                        <div class="col">
                            <table-data
                                :route="url.getResources.replace(':id', this.$route.params.id)"
                                :settings="table.settings"
                                :columns="columns"
                                :inlineFilters="table.filters"
                                :autoUpdateFilter="table.autoUpdateFilter"
                                :addParamsToUrl="table.addParamsToUrl"
                                :loadingMsg="table.loadingMsg"
                                :notFoundMsg="table.notFoundMsg"
                                :orderByTemplate="table.orderByTemplate"
                                tableClass=""
                                @error-load="showError"
                            >
                                <template v-slot:body="{row, index, remove}">
                                    <td :class="table.columns[0].class">{{row.title}}</td>
                                    <td :class="table.columns[1].class">{{row.abstract}}</td>
                                    <column-actions v-if="canHarvest" :row="row" :index="index" >
                                        <template v-slot:default="{confirm, formatMsg}">
                                            <li title="Unlink Resource">
                                                <i class="cursor-pointer fas fa-unlink action delete" @click="confirm((id, data)=>{ unlinkResource(id, data).then(data => {if(data){form.layers_count--;return remove(data.id, data.index);}});}, row.id, index, formatMsg(unlinkResourceTemplate))"></i>
                                            </li>
                                        </template>
                                    </column-actions>
                                </template>
                            </table-data>
                        </div>
                    </div>
                    <div class="row" v-else>
                        <div class="col">
                            <p>{{noResources}}</p>
                        </div>
                    </div>

                    <buttons-footer
                        :enableButtons="!readonlyFormItem && canHarvest"
                        :cancelTitle="btnBackTitle"
                        :submitTitle="submitTitle"
                        :isDisabled="false"
                        @save="harvest"
                        @cancel="handleBack(`${moduleCode}.${pageID}`, true)"
                    >
                    </buttons-footer>
                </form>
            </div>
    	</div>
    </layout>
</template>

<script>
	import GeneralMixin     from './../../mixin';

    export default {
        mixins: [
            GeneralMixin,
        ],
    	data() {
      		return {
      			pageID: 'ogc_remote_services',
                pageTitle: 'Service',
                emptyField: '',
                noResources: 'No resources have been imported yet.', //No resources have been imported yet.
                submitTitle: 'Import Service Resources', //Import Service Resources
                unlinkResourceTemplate: 'Are you sure you want to unlink <u>{title}</u>?',
                form: {
                    id: null,
                    url: null,
                    ogc_service_id: null,
                    service: null,
                    title: null,
                    description: null,
                    abstract: null,
                    keywords: null,
                    layers: [],
                    layers_count: 0,
                    resources_count: 0,
                    unlyrsids: [],
                },
                table: {
                    settings: {
                        order_by: 'title',
                    },
                    columns: [
                        {
                            label: 'Title',
                            field: 'title',
                            class: '',
                            sortable: true,
                        },
                        {
                            label: 'Description',
                            field: 'abstract',
                            class: 'd-none d-sm-table-cell',
                            sortable: false,
                        },
                        {
                            label: '',
                            field:  null,
                            sortable: false,
                            class: 'actions',
                        }
                    ],
                },
      		}
    	},
        computed: {
            columns() {
                return this.canHarvest ? this.table.columns : this.table.columns.slice(0, -1);
            },
        },
    	methods: {
            harvest() {
                this.$router.push({ name: `${this.moduleCode}.${this.pageID}.harvest`});
            },
            async unlinkResource(id, data, callback) {
                if(this.canHarvest)
                {
                    this.form.unlyrsids = [id];
                    return await this.saveItem(null, null, {id, ...data});
                    // .then((data) => {
                    //     // if(data){
                    //     //     this.form.layers_count--;
                    //     //     remove(data.id, data.index);

                    //     // }
                    // })
                }
            },
    	}
  	}
</script>

<style scoped lang="scss">
    .form-group.form-inline {
        opacity: 0.6;
    }
</style>

